import { useQuery } from '@tanstack/react-query'

import { trendsApi } from '@/api/endpoints'
import { keys } from '@/api/keys'

/** 服务端本来就缓存 5 分钟，前端跟着 5 分钟 */
export function useTrends() {
  return useQuery({
    queryKey: keys.trends(),
    queryFn: () => trendsApi.list(),
    staleTime: 5 * 60 * 1000,
  })
}
